import { INormalizedKnockout, INormalizedKnockoutGroup } from '../../../../types';
import { SMPContainer } from '../../../index';
import { KnockoutDesktop } from './components/KnockoutDesktop';
import { KnockoutMobile } from './components/KnockoutMobile';
import { useIsSmartphoneDevice } from '../../../../hooks/useIsSmartphoneDevice';
import { useMemo, useRef } from 'react';
import { ACTIVE } from '../../../../constants/actitivityStatus';

export interface IKnockoutProps {
  normalizedKnockoutData?: INormalizedKnockout[];
  smallFinalName?: string;
  hasSmallFinal?: boolean;
  handleTeamClick?: (id: string | number, name: string) => void;
  handleEventClick?: (id: string | number) => void;
}

const getKnockoutData = (normalizedKnockoutData?: INormalizedKnockout[]) => {
  if (!normalizedKnockoutData || normalizedKnockoutData.length === 0) {
    return { names: [], groupGames: [], maxSteps: 0, activeStep: 0 };
  }

  const names = normalizedKnockoutData.map(({ name }) => name);
  const groupGames = normalizedKnockoutData.map(({ groups }) => groups);
  const maxSteps = normalizedKnockoutData.length;
  const activeRound = normalizedKnockoutData.findIndex(({ status }) => status === ACTIVE);
  const activeStep = activeRound < 0 || undefined ? 0 : activeRound;

  return { names, groupGames, maxSteps, activeStep: activeStep };
};

export const Knockout = ({ normalizedKnockoutData, smallFinalName, hasSmallFinal, handleEventClick }: IKnockoutProps): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const { isMobile } = useIsSmartphoneDevice(ref);

  const { names, groupGames, maxSteps, activeStep } = useMemo(() => {
    return getKnockoutData(normalizedKnockoutData);
  }, [normalizedKnockoutData]);

  return (
    <SMPContainer
      ref={ref}
      style={{ paddingRight: isMobile ? '0' : '$3', paddingLeft: isMobile ? '0' : '$3' }}
      css={{
        paddingBottom: '$3',
        paddingTop: '$3',
        position: 'relative',
        backgroundColor: '$knockoutBgColor',
      }}
    >
      <KnockoutMobile
        isMobile={isMobile}
        activeStep={activeStep}
        maxSteps={maxSteps}
        knockoutGroupGames={groupGames as INormalizedKnockoutGroup[][]}
        knockoutGroupNames={names}
        smallFinalName={smallFinalName}
        hasSmallFinal={hasSmallFinal}
        handleEventClick={handleEventClick}
        isPlayoff={false}
      />

      {!isMobile && (
        <KnockoutDesktop
          handleEventClick={handleEventClick}
          knockoutGroupGames={groupGames as INormalizedKnockoutGroup[][]}
          knockoutGroupNames={names}
          smallFinalName={smallFinalName}
          hasSmallFinal={hasSmallFinal}
          isPlayoff={false}
        />
      )}
    </SMPContainer>
  );
};
